/**
 * Match CRM stages across subpipelines by normalized name set (hu/sk/en/legacy name).
 * Same logical stage in different pipelines should share the same fingerprint if names match.
 */

export function stageMatchFingerprint(s: {
  id?: string;
  name?: string | null;
  name_hu?: string | null;
  name_sk?: string | null;
  name_en?: string | null;
}): string {
  const parts = [s.name_hu, s.name_sk, s.name_en, s.name]
    .map((x) => (x != null ? String(x).trim().toLowerCase() : ""))
    .filter(Boolean);
  if (parts.length === 0) return `id:${s.id ?? "unknown"}`;
  return [...new Set(parts)].sort().join("\u0001");
}
